/* DocumentosPage.tsx – MUI Tabs: Tipos | Enviar | Histórico */
import { useState } from "react";
import { Box, Tabs, Tab, Typography, Divider } from "@mui/material";
import TiposDocumentosPage from "./TiposDocumentosPage"; // tabla que ya hicimos
// TODO: crea estos dos cuando llegues a ellos
import EnviarDocumentoPage from "./EnviasDocumentoPage";
//import HistoricoDocumentosPage from './HistoricoDocumentosPage';
import HistoricoDocumentosPage from "./HistoricoDocumentosPage";
export default function DocumentosPage() {
  const [tab, setTab] = useState(0);

  return (
    <Box p={3}>
      <Typography variant="h5" gutterBottom>
        Gestión de documentos
      </Typography>

      <Tabs value={tab} onChange={(_, v) => setTab(v)} sx={{ mb: 2 }}>
        <Tab label="Tipos" />
        <Tab label="Enviar" />
        <Tab label="Histórico" />
      </Tabs>
      <Divider sx={{ mb: 2 }} />

      {tab === 0 && <TiposDocumentosPage />}
      {tab === 1 && <EnviarDocumentoPage />}
      {tab === 2 && <HistoricoDocumentosPage />}
    </Box>
  );
}
